export default __webpack_public_path__ + "static/media/5.a01ab0ce.jpg";